// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"styles_tableHeader__1Bf7n","number":"styles_number__XbkLZ","name":"styles_name__2eu_d","holding":"styles_holding__2XFpm","usdValue":"styles_usdValue__24Veu"};